export enum ProductStates {
  ADDED_TO_ORDER = 'ADDED_TO_ORDER',
  NOT_ADDED_TO_ORDER = 'NOT_ADDED_TO_ORDER',
  OUT_OF_STOCK = 'OUT_OF_STOCK',
  QUANTITY_DID_UPDATE = 'QUANTITY_DID_UPDATE'
}
